<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles orderDetails">
            <van-nav-bar
                title="订单详情"
                left-text="订单管理"
                left-arrow
                @click-left="onClickLeft"
            ></van-nav-bar>
            <section :class="{'readOnly': !isReadOnly}">
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>基础信息
                        </div>
                        <van-cell
                            :value="orderDetailsData.order_number"
                            title="订单编号"
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.bill_time"
                            title="登记时间"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.contract_number"
                            title="合同编号"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.contract_typename"
                            title="合同类型"
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.project_name"
                            title="工程名称"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.project_type_name"
                            title="工程类型"
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.project_address"
                            title="工程地址"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.project_address1"
                            title="当前收货地址"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.monomer_name"
                            title="相关单体"
                            :icon="require('@/assets/images/icons/icon_gy_8.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.cons_floor"
                            title="施工楼层"
                            :icon="require('@/assets/images/icons/icon_gy_8.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.customer_name"
                            title="客户名称"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.customer_xydm"
                            title="统一信用代码"
                            :icon="require('@/assets/images/icons/icon_33.png')"
                        ></van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_3.png')"
                            title="要料人"
                            :value="orderDetailsData.gdylr"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_4.png')"
                            title="联系电话"
                            :value="orderDetailsData.gdylr_phone"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            title="供应站点"
                            :value="orderDetailsData.station_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_10.png')"
                            title="运距"
                            :value="orderDetailsData.haul_distance"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_30.png')"
                            title="计划方量"
                            :value="orderDetailsData.quantity"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_3.png')"
                            title="现场联系人"
                            :value="orderDetailsData.xclxr"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_4.png')"
                            title="联系电话"
                            :value="orderDetailsData.xclxr_phone"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            title="到货时间"
                            :value="orderDetailsData.arrival_time"
                        >
                        </van-cell>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            <i class="iconfont iconlianxiren"></i>其他信息
                        </div>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            title="强度等级"
                            :value="orderDetailsData.strength_grade_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_6.png')"
                            title="附加型号"
                            :value="orderDetailsData.special_require_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            title="工程结构"
                            :value="orderDetailsData.place_category_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            title="施工部位"
                            :value="orderDetailsData.place_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_4.png')"
                            title="施工部位描述"
                            :value="orderDetailsData.place_detail"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_11.png')"
                            title="运输方式"
                            :value="orderDetailsData.transport_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_32.png')"
                            title="浇筑方式"
                            :value="orderDetailsData.pouring_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            title="泵车类型"
                            :value="orderDetailsData.pump_truck_name"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_32.png')"
                            title="坍落度"
                            :value="orderDetailsData.slump_name	"
                        >
                        </van-cell>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_4.png')"
                            title="备注"
                            :value="orderDetailsData.remarks"
                        >
                        </van-cell>
                    </van-collapse-item>
                </van-collapse>
            </section>
            <footer v-if="isReadOnly">
                <button class="confirm" @click="orderConfirm">
                    确认订单
                </button>
                <!-- pageID = retail, 零售订单确认， 没有退回功能 -->
                <button class="cancel" @click="orderCancel" v-if="pageID !== 'retail'">
                    退回订单
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 订单详情
    name: 'order-details',
    components: {},
    props: {},
    data() {
        return {
            pageID: '',
            activeNames: ['1', '2'],
            // 订单详情数据
            orderDetailsData: {},
            // 是否是只读
            isReadOnly: false,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.pageID = this.$route.params.pageID;
        this.orderDetailsData = this.$route.params.data;
        if (this.orderDetailsData.status < 2) {
            this.isReadOnly = true;
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 订单确认
        orderConfirm() {
            this.$axios
                .put('/interfaceApi/production/productorder/confirme/' + this.orderDetailsData.order_number)
                .then(res => {
                    if (res) {
                        if (res.ResultCode === 1) {
                            this.$router.isBack = 1;
                            this.$router.push({
                                name: 'orderConfirmation',
                                params: {
                                    confirmCallback: this.orderDetailsData.order_number,
                                },
                            });
                            this.$toast.success('确认成功!');
                        } else if (res.ResultCode === 2) {
                            this.$dialog.alert({
                                message: res.Description,
                            }).then(() => {
                                this.$router.isBack = 1;
                                this.$router.push({
                                    name: 'orderConfirmation',
                                    params: {
                                        confirmCallback: this.orderDetailsData.order_number,
                                    },
                                });
                                this.$toast.success('确认成功!');
                            });
                        } else {
                            this.$dialog.alert({
                                message: res.Description,
                            }).then(() => {});
                        }
                    }
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 订单取消
        orderCancel() {
            this.$axios
                .put('/interfaceApi/production/productorder/repulse/' + this.orderDetailsData.order_number)
                .then(() => {
                    this.$router.isBack = 1;
                    this.$router.push({ path: '/orderConfirmation' });
                    this.$toast.success('退回成功!');
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus">
.orderDetails
    height 100%
    section
        height calc(100% - 90rpx)
        margin-bottom 5rpx
        &.readOnly
            height calc(100% - 45rpx)
    .van-icon
        .van-icon__image
            width 16rpx
            height 16rpx
            margin-top 3rpx
            margin-right 5rpx
    .van-collapse
        &:after
            display none
    .van-cell__title
        width 100rpx
        font-size 18rpx
        line-height 24rpx
        color #061F3E
        .iconfont
            font-size 18rpx
            margin-right 5rpx
    .van-collapse-item__content
        .van-cell__title
            font-size 16rpx
    .title
        font-size 17rpx
        color #3495FB
    .van-collapse-item__content
        padding 0
    .van-field__control,
    .van-cell__value
        color #979EA7
        &::placeholder
            color #D7D7D7 !important
    .textarea
        position relative
        &:before
            position absolute
            top 20rpx
            left 26rpx
        textarea
            text-indent 30rpx
            &.van-field__control
                border 1px solid #D7D7D7
                border-radius 4px
                padding 10rpx
                height 130rpx !important
    footer
        height 40rpx
        display: flex
        button
            flex 1
            height 40rpx
            border none
            border-top 1px solid #D60110
            font-size 16rpx
            background none
            &.confirm
                background #D60110
                color #fff
            &.cancel
                color #D60110
</style>